export default "__VITE_ASSET__BJ4Cs433__"